import Created from './Created';
import Name from './Name';
import ShortName from './ShortName';
import Updated from './Updated';
import TaxNumber from './TaxNumber';
import EUTaxNumber from './EUTaxNumber';
import BillingAddress from './BillingAddress';
import DeliveryAddress from './DeliveryAddress';
import MailingAddress from './MailingAddress';
import FELIR from './FELIR';
import GroupTaxNumber from './GroupTaxNumber';
import Status from './Status';
import RegistrationNumber from './RegistrationNumber';
import Id from './Id';
import IsOrderIdRequired from './IsOrderIdRequired';
import CustomerGroups from './CustomerGroups';

export const labels = {
  Id: 'Id',
  Name: 'Hivatalos név',
  ShortName: 'Rövid név',
  TaxNumber: 'Adószám',
  EUTaxNumber: 'EU adószám',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
  BillingAddress: 'Számlázási cím',
  DeliveryAddress: 'Szállítási cím',
  MailingAddress: 'Levelezési cím',
  FELIR: 'FELIR',
  GroupTaxNumber: 'Csoportos adószám',
  Status: 'Státusz',
  RegistrationNumber: 'Cégjegyzékszám',
  IsOrderIdRequired: 'Megrendelésszám kötelező',
  CustomerGroups: 'Vevőcsoport',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'ShortName',
}, {
  value: 'TaxNumber',
}, {
  value: 'EUTaxNumber',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'BillingAddress',
}, {
  value: 'MailingAddress',
}, {
  value: 'DeliveryAddress',
}, {
  value: 'FELIR',
}, {
  value: 'GroupTaxNumber',
}, {
  value: 'Status',
}, {
  value: 'RegistrationNumber',
}, {
  value: 'IsOrderIdRequired'
}, {
  value: 'CustomerGroups'
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'ShortName',
}, {
  value: 'TaxNumber',
}, {
  value: 'EUTaxNumber',
}, {
  value: 'CustomerGroups',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Created,
  Updated,
  Name,
  ShortName,
  TaxNumber,
  EUTaxNumber,
  BillingAddress,
  MailingAddress,
  DeliveryAddress,
  RegistrationNumber,
  FELIR,
  GroupTaxNumber,
  Status,
  Id,
  IsOrderIdRequired,
  CustomerGroups,
};
